import { showStarRatingErrorBlock } from './show-star-rating-error-block';
import { setStarRatingTitleInvalid } from './set-star-rating-title-invalid';
import { setStarRatingHintInvalid } from './set-star-rating-hint-invalid';
import { scrollStarsIntoView } from './scroll-stars-into-view';
import { setSubmitButtonState } from '../../../helper/set-submit-button-state';

export type HandleStarRatingInvalidParams = {
    rootElement: Pick<HTMLElement, 'querySelector'>;
};
export const handleStarRatingInvalid = ({ rootElement }: HandleStarRatingInvalidParams) => {
    setStarRatingHintInvalid({ rootElement });
    setStarRatingTitleInvalid({ rootElement });
    showStarRatingErrorBlock({ rootElement });
    scrollStarsIntoView({ rootElement });
    setSubmitButtonState({ rootElement, disabled: true, loading: false });
};
